module.exports = __webpack_public_path__ + "img/slider.08179fa2.jpg";